import React from 'react';
import { Card, Button, Tooltip } from 'element-react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import PlusIconSVG from './PlusIconSVG'; // O la ruta correcta a tu SVG

const AddProductCard = ({ onAddProduct }) => {
    const { t } = useTranslation();
    const history = useHistory();

    // Esta es la función que navega a la página de añadir producto
    const toAddProduct = () => {
        if (onAddProduct) {
            onAddProduct();
        } else {
            history.push('/add-product-wizard/0');
        }
    };

    return (
        <Card className="product-box add-product-card">
            
            <Tooltip content={t('add_product_card.tooltip', 'Add Product')} placement="bottom">
                <div className="add-icon-wrapper" onClick={toAddProduct}>
                    <PlusIconSVG />
                </div>
            </Tooltip>
            <div className="add-product-content">
                <div className="next-step-icon-container">
                    <i className="el-icon-check next-step-icon"></i>
                    <div className="next-step-text">
                        {t('add_product_card.next_step', 'Next Step')}
                    </div>
                </div>
                <div className="list-products-text">
                    {t('add_product_card.list_here', 'List your Products Here')}
                </div>
                <Button className="add-products-now-button" onClick={toAddProduct} type="primary">
                    {t('add_product_card.button', 'Add Products Now')}
                </Button>
            </div>
        </Card>
    );
};

export default AddProductCard;